
const config = {
    version: '0.1.0',
    serverUrl:process.env.REACT_APP_SERVER_URL,
}

export default config;